import { type TOC } from '@ember/component/template-only';
import { or } from 'ember-truth-helpers';

export interface DropdownDividerSignature {
  Args: {
    label?: string;
  };
  Blocks: { default: [] };
  Element: HTMLDivElement;
}

const DropdownDivider: TOC<DropdownDividerSignature> = <template>
  {{#if (or (has-block) @label)}}
    <div class='semeia-dropdown ui dividing header' ...attributes>
      {{#if (has-block)}}
        {{yield}}
      {{else}}
        {{@label}}
      {{/if}}
    </div>
  {{else}}
    <div class='divider'></div>
  {{/if}}
</template>;

export default DropdownDivider;
